<template>
<div>
    <div class="columns" v-show="!isEditing" v-bind:class="showActiveBorder(data.status)">
        <div class="column is-7">
            <p class="subtitle" v-on:click="viewSubmissions(data.id,data.name)" style="cursor: pointer">
            {{ data.name }}
            </p>
        </div>
        <div class="column">
            <a class="button is-info is-small light-blue" v-on:click="viewSubmissions(data.id,data.name)">Submissions</a>
        </div>
        <div class="column">
            <a class="button is-info is-small light-grey" v-on:click="displayLinkQRPage(data.template,data.id,data.name)">Link QR</a>
        </div>
        <div class="column">
            <a class="button is-info is-small light-purple" v-on:click="viewSubmissionsInExcel(data.id,data.name)">Excel</a>
        </div>
        <div class="column">
            <a class="button is-info is-small yellow" v-on:click="edit(data)">Edit</a>
        </div>
        <div class="column">
            <a class="button is-info is-small light-red" v-on:click="deleteData(data)">Remove</a>
        </div>
        <!-- <div class="column is-5">
            <div class="field has-addons" style="float: right">
                <div class='extra content'>
                    <a class="button is-info is-small light-blue" v-on:click="viewSubmissions(data.id,data.name)">
                    Submissions
                    </a>
                    <a class="button is-info is-small light-grey" v-on:click="displayLinkQRPage(data.template,data.id,data.name)">
                    Link QR
                    </a>
                    <a class="button is-info is-small light-purple" v-on:click="viewSubmissionsInExcel(data.id,data.name)">
                    Excel
                    </a>
                    <a class="button is-info is-small yellow" v-on:click="edit(data)">
                    Edit
                    </a>
                    <a class="button is-info is-small light-red" v-on:click="deleteData(data)">
                    Remove
                    </a>
                </div>
            </div>
        </div> -->
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    props: ['data'],
    components:{
    },
    data() {
        return {
            isEditing: false,
        };
    },
    created() {
    },
    methods: {        
        viewSubmissions(id,name){        
            this.$store.commit('UPDATE_FORM_ID',id)
            this.$store.commit('UPDATE_FORM_NAME',name)
            localStorage.setItem('FORM_ID',id)
            localStorage.setItem('FORM_NAME',name)
            this.$router.push({
                name: "ManageFormsSubmissions"
            });
        },
        viewSubmissionsInExcel(id,name){        
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            // axios.defaults.responseType = 'blob'
            axios.defaults.responseType = 'json'
            axios.defaults.timeout = 0
            axios.post(process.env.NEW_ENDPOINT + '/form/listSubmissionsInExcel', {
                    loginEmail: localStorage.getItem('email'),
                    token: localStorage.getItem('newToken'),
                    schoolId: localStorage.getItem('schoolID'),
                    country: localStorage.getItem('country'),
                    formId: id
                })
            .then(response => {
                console.log("109 response")
                console.log(response.data)

                window.location.href = response.data.url
                // const url = window.URL.createObjectURL(new Blob([response.data]));
                // const link = document.createElement('a');
                // link.href = url;
                // link.setAttribute('download', name + "_submissions.xlsx"); 
                // document.body.appendChild(link);
                // link.click();
                })
                .catch(e => {
                    console.log(e)
                })
        },
        edit(data){
            console.log("entering edit with data")
            console.log(data.id)
            console.log(data.name)
            this.$store.commit('UPDATE_FORM_ID',data.id)
            this.$store.commit('UPDATE_FORM_NAME',data.name)
            this.$store.commit('UPDATE_FORM_STATUS',data.status)
            this.$store.commit('UPDATE_FORM_FIELDS',data.content)
            localStorage.setItem('FORM_ID',data.id)
            localStorage.setItem('FORM_NAME',data.name)
            localStorage.setItem('FORM_STATUS',data.status)
            localStorage.setItem('FORM_FIELDS',data.content)
            this.$router.push({
                name: "ManageFormsEdit"
            });
        },
        displayLinkQRPage(template,id,name){
            var country = localStorage.getItem('country')
            var schoolNo = localStorage.getItem('schoolNo')
            let routeData = this.$router.resolve({name: 'DbFormDisplayLinkQR', query: {country: country, schoolNo: schoolNo, template: template, id: id, name: name}});
            window.open(routeData.href, '_blank');
        },
        showActiveBorder(isActive){
            if (isActive == "1"){
            return "status-active-contents";
            }else{          
            return "status-inactive-contents";
            }
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
    },
};
</script>
<style scoped>
.light-blue{
    background-color: #49c3ff;
    color: #000;
}
.light-blue{
    background-color: #ffe849;
    color: #000;
}
.light-grey{
    background-color: #e6e6e6;
    color: #000;
}
.light-purple{
    background-color: #e88bff;
    color: #000;
}
.light-red{
    background-color: #ff5e5e;
    color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Forms/DataView.vue